import React, { useState } from 'react';
import { getSDWT } from 'Utils/Helpers';
import styled from 'styled-components';

const SecretArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    .secret-hide {
        opacity: 0;
        cursor: default;
        color: #fff;
        transition: opacity 0.3s ease;
    }

    .secret-show {
        cursor: pointer;
        border: 1px solid rgb(233, 236, 239);
        border-radius: 10px;
        color: #000;
        opacity: 1;
        transition: opacity 0.3s ease;

        &:hover {
            // Styles for hover state
            background-color: rgba(233, 236, 239, 0.2);
        }

        &:active {
            // Styles for active state
            background-color: rgba(233, 236, 239, 0.4);
        }
    }
`;

const DWTSecretArea = () => {
    const [clickCount, setClickCount] = useState(0);

    const handleClick = () => {
        if (getSDWT(process.env.REACT_APP_DEV_MODE_KEY, process.env.REACT_APP_DEV_MODE_VALUE)) return;
        const newCount = clickCount + 1;
        setClickCount(newCount);

        if (newCount === 6) {
            localStorage.setItem(process.env.REACT_APP_DEV_MODE_KEY, process.env.REACT_APP_DEV_MODE_VALUE);
            window.location.reload();
        }
    };

    return (
        <SecretArea>
            <div onClick={handleClick} className={`p-2 ${clickCount <= 2 ? 'secret-hide' : 'secret-show'}`}>
                <div>{6 - clickCount} Clicks to enable Dev-Mode</div>
            </div>
        </SecretArea>
    );
};

export default DWTSecretArea;
